<template>
    <div class="container">
        <div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item
                    :to="{ path: $myRouter.getPreviousRoute().path, params: $myRouter.getPreviousRoute().params }">返回列表</el-breadcrumb-item>
                <el-breadcrumb-item>场所日志</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <hr>
        <div class="center-container">
            <el-timeline :reverse="reverse">
                <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.timestamp">
                    {{ activity.content }}
                </el-timeline-item>
            </el-timeline>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            project_id: '',
            site_id: '',
            reverse: true,
            activities: []
        }
    },
    methods: {
        async getList() {
            let params = {
                project_id: this.project_id,
                site_id: this.site_id
            };
            let res = await this.$Api.get('site_status', { params: params });
            if (res) {
                this.activities = res;
            }
        }
    },
    created() {
        this.project_id = this.$route.params.project_id;
        this.site_id = this.$route.params.site_id;
        this.getList();
    }
}
</script>
<style scoped>
.center-container {
    display: flex;
    justify-content: left;
    align-items: center;
    margin-top: 20px;
}
</style>